import { useVendorsApiClient } from 'vendors/api/useVendorsApiClient'
import { useQuery, UseQueryResult, useQueryClient, UseMutationResult, useMutation } from '@tanstack/react-query'

export const useGetWorkRegions = (): UseQueryResult<WorkRegionsResponseType[]> => {
  const { getWorkRegions } = useVendorsApiClient()

  return useQuery<WorkRegionsResponseType[]>({
    queryKey: ['get-work-regions'],
    queryFn: () => getWorkRegions(),
    refetchOnWindowFocus: false
  })
}

export const useGetVendorWorkRegions = (vendorId: string): UseQueryResult<VendorWorkRegion[]> => {
  const { getWorkRegionsByVendorId } = useVendorsApiClient()

  return useQuery<VendorWorkRegion[]>({
    queryKey: ['vendor-work-regions', vendorId],
    queryFn: () => getWorkRegionsByVendorId(vendorId),
    enabled: vendorId !== '',
    refetchOnWindowFocus: false
  })
}

export const useSetWorkRegionForVendor = (vendorId: string): UseMutationResult<unknown, unknown, string, unknown> => {
  const { setWorkRegionForVendorId } = useVendorsApiClient()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (workRegionId: string) => setWorkRegionForVendorId(vendorId, workRegionId),
    onMutate: (workRegionId) => {
      queryClient.setQueryData(
        ['vendor-work-regions', vendorId],
        (oldData: VendorWorkRegion[] = []): VendorWorkRegion[] => {
          return [
            ...oldData,
            {
              id: '',
              workRegionId: workRegionId,
              name: ''
            }
          ]
        }
      )
    }
  })
}

export const useEndWorkRegionForVendor = (vendorId: string): UseMutationResult<unknown, unknown, string, unknown> => {
  const { deleteWorkRegionFromVendorId } = useVendorsApiClient()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (workRegionId: string) => deleteWorkRegionFromVendorId(vendorId, workRegionId),
    onMutate: (workRegionId) => {
      queryClient.setQueryData(
        ['vendor-work-regions', vendorId],
        (oldData: VendorWorkRegion[] = []): VendorWorkRegion[] => {
          return oldData.filter((item) => item.workRegionId !== workRegionId)
        }
      )
    }
  })
}
